var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A9B9CB;}\r\n\t.st1{fill:#7F8B99;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M483.48,150.49c0-8.56-1.82-16.27-5.61-22.72c-3.65-6.45-9.12-11.78-16.41-15.99 C400.88,76.85,340.29,41.93,279.7,7.01c-16.27-9.4-32.12-9.12-48.39,0.42C207.19,21.6,86.44,90.88,50.54,111.78 c-14.87,8.56-22.02,21.74-22.02,38.85c0,70.26,0,140.67,0,210.93c0,8.41,1.82,15.85,5.33,22.3c3.65,6.59,9.26,12.2,16.69,16.55 c36.04,20.9,156.66,90.04,180.78,104.34c16.27,9.54,31.98,9.96,48.39,0.42c60.59-35.06,121.17-69.84,181.76-104.77 c7.57-4.35,13.04-9.82,16.69-16.55c3.51-6.45,5.33-13.88,5.33-22.3C483.48,361.42,483.48,220.75,483.48,150.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M279.28,7.29c-16.27-9.4-32.12-9.12-48.25,0.42c-24.12,14.17-144.6,83.31-180.5,104.06 c-14.73,8.56-22.02,21.6-22.02,38.71c0,70.12,0,140.25,0,210.37c0,8.41,1.82,15.85,5.33,22.3c3.65,6.59,9.26,12.06,16.69,16.41 c8.27,4.77,20.9,12.06,35.76,20.62L418.83,87.65C372.27,61.01,325.84,34.22,279.28,7.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st2",
    d: "M302.98,223.84l70.83,0.56c0-29.45-29.87-101.82-115.42-101.82 c-54.56,0-127.91,34.64-127.91,134.36s71.95,132.25,127.91,132.25c90.74,0,112.34-62.69,112.34-98.17l-67.6-3.93 c0,0,1.82,40.95-45.16,40.95c-43.34,0-50.63-53.15-50.63-71.11c0-27.49,9.82-71.53,50.63-71.53 C298.78,185.55,302.98,223.84,302.98,223.84"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.bfe10c09d91b35d93af8de3b753a8ca5.svg";
export { ForwardRef as ReactComponent };